import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';

export const SameFeeFill = ({ roles, disabled, onFill }) => {
  const [all, setAll] = useState('');
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-slate-500 whitespace-nowrap">Same fee for every role</span>
      <Input type="number" min="0" step="0.01" value={all} disabled={disabled} onChange={e => setAll(e.target.value)}
        placeholder="e.g. 35.00" className="h-9 flex-1 min-w-0" data-testid="rates-same-fee-input" />
      <Button type="button" size="sm" variant="outline" disabled={disabled || all === ''} data-testid="rates-same-fee-btn"
        onClick={() => onFill(Object.fromEntries(roles.map(r => [r.key, all])))}>Fill all</Button>
    </div>
  );
};

export const ApplyPastToggle = ({ checked, disabled, onChange }) => (
  <label htmlFor="rates-apply-past" className={`flex items-start gap-2.5 rounded-lg border px-3 py-2.5 transition-colors ${checked ? 'border-amber-300 bg-amber-50' : 'border-slate-200 bg-slate-50'} ${disabled ? 'opacity-60' : 'cursor-pointer'}`}>
    <Checkbox id="rates-apply-past" checked={checked} disabled={disabled} onCheckedChange={v => onChange(!!v)} className="mt-0.5" data-testid="rates-apply-past" />
    <span className="text-xs text-slate-600 leading-relaxed">
      <b className="block text-sm text-slate-800">Also apply to past games</b>
      Unpaid games get the new fee (approved ones go back to Verified for re-approval). Paid games, or games already in a payment batch,
      keep their amount and get one Rate Adjustment for the difference. Manual fee overrides are kept.
    </span>
  </label>
);

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

export const pastSummary = (p, fmt) => {
  if (!p) return '';
  const total = p.adjustments.reduce((s, a) => s + a.amount_minor, 0);
  return [
    `${plural(p.repriced, 'past game')} re-priced`,
    p.unapproved && `${p.unapproved} sent back for re-approval`,
    p.adjustments.length && `${plural(p.adjustments.length, 'rate adjustment')} added (${total > 0 ? '+' : ''}${fmt(total)})`,
    p.kept_overrides && `${plural(p.kept_overrides, 'manual override')} kept`,
  ].filter(Boolean).join(' · ');
};
